import usePhaserGame from '../../../hooks/usePhaserGame';
import PantallaCarga from './JuegoTragamonedas/PantallaCarga';
import JuegoTragamonedas from './JuegoTragamonedas/JuegoTragamonedas';

const PhaserTragamonedas = () => {
  usePhaserGame({
    scenes: [PantallaCarga, JuegoTragamonedas],
    width: 750,
    height: 450,
    containerId: 'phaser-tragamonedas',
    useSaldoDirecto: true,
  });

  return <div id="phaser-tragamonedas" />;
};

export default PhaserTragamonedas;
